import type { EventParams } from '@yandex-int/k-common';
import { WebinarEventBaseCert2025 as getWebinarEventBaseCert2025 } from './webinarEventBaseCert2025';

/** Серт для события */
export const EventCert = (params: EventParams) => {
    const {
        school_name,
        locality,
        first_name,
        middle_name,
        last_name,
        event_duration,
        event_date,
        event_description,
        isNewCert2025,
    } = params;

    if (isNewCert2025) {
        return getWebinarEventBaseCert2025({ slug: 'event', ...params });
    }

    return `
        <!DOCTYPE html>
        <html lang="ru">
            <head>
                <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <link rel="stylesheet" href="https://e7n.s3.yandex.net/static/fonts/ys2/fonts.css" />
                <title>Сертификат за событие</title>
                <style>
                    @page {
                        size: 210mm 297mm;
                        margin: 0;
                    }

                    @media print {
                        html,
                        body {
                            color-adjust: exact;
                            print-color-adjust: exact;
                            -webkit-print-color-adjust: exact;
                        }
                    }

                    *,
                    *:before,
                    *:after {
                        box-sizing: border-box;
                        padding: 0;
                        margin: 0;
                    }

                    body {
                        color: #201e1e;

                        position: relative;

                        width: 210mm;
                        height: 297mm;

                        background: #ffffff;
                        box-sizing: border-box;
                        overflow: hidden;

                        page-break-after: always;
                        font-family: 'YS Text';
                        font-weight: 400;
                        font-style: normal;
                    }

                    .certificate__content {
                        padding: calc(34mm * 210 / 595);
                        padding-bottom: calc(15mm * 210 / 595);

                        height: 100%;
                        display: flex;
                    }

                    .certificate__background-image {
                        position: absolute;
                        top: 0;
                        right: 0;
                        height: 100%;
                        width: calc(209mm * 210 / 595);
                        z-index: -1;
                    }

                    .certificate__column {
                        height: 100%;
                    }

                    .certificate__column_left {
                        width: calc(327mm * 210 / 595);

                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                    }

                    .certificate__header {
                        font-weight: 700;
                        font-size: calc(30mm * 210 / 595);
                        line-height: calc(36mm * 210 / 595);

                        text-transform: uppercase;

                        margin: calc(66mm * 210 / 595) 0 calc(18mm * 210 / 595);
                    }

                    .certificate__school-data {
                        font-size: calc(14mm * 210 / 595);
                        line-height: calc(20mm * 210 / 595);

                        margin-bottom: calc(54mm * 210 / 595);
                    }

                    .certificate__teacher-data {
                        font-weight: 700;
                        font-size: calc(22mm * 210 / 595);
                        line-height: calc(30mm * 210 / 595);
                        text-transform: uppercase;
                        font-family: 'YS Display';

                        margin-bottom: calc(54mm * 210 / 595);
                    }

                    .certificate__description {
                        font-size: calc(16mm * 210 / 595);
                        line-height: calc(22mm * 210 / 595);
                    }

                    .certificate__event-data {
                        font-size: calc(14mm * 210 / 595);
                        line-height: calc(20mm * 210 / 595);
                        white-space: nowrap;

                        margin-bottom: calc(40mm * 210 / 595);
                    }

                    .signature {
                        display: flex;
                        align-items: center;
                    }

                    .signature__description {
                        font-size: calc(12mm * 210 / 595);
                        line-height: calc(17mm * 210 / 595);
                        flex-shrink: 0;

                        margin-right: calc(47mm * 210 / 595);
                    }

                    .signature__image {
                        height: calc(120mm * 210 / 595);
                    }

                    .certificate__book-logo {
                        width: calc(199mm * 210 / 595);
                        height: calc(26mm * 210 / 595);
                    }
                </style>
            </head>
            <body>
                <div class="certificate__content">
                    <img
                        src="https://e7n.s3.yandex.net/static/certificates/violet-cubes.png"
                        alt="cubes"
                        class="certificate__background-image"
                    />

                    <div class="certificate__column certificate__column_left">
                        <div class="text-wrapper">
                            <div class="certificate__header">Сертификат</div>

                            <div class="certificate__school-data">
                                настоящий сертификат подтверждает, <br />что учитель ${school_name}, ${locality}
                            </div>

                            <div class="certificate__teacher-data">
                                ${last_name} <br />
                                ${first_name} <br />
                                ${middle_name}
                            </div>

                            <div class="certificate__description">${event_description}</div>
                        </div>

                        <div class="certificate__bottom-info-wrapper">
                            <div class="certificate__event-data">
                                г. Москва<br />
                                ${event_duration} ・ ${event_date}
                            </div>

                            <div class="signature">
                                <div class="signature__description">
                                    Директор по взаимодействию<br />
                                    с органами власти в сфере<br />
                                    образования<br />
                                    <br />
                                    Д.А. Растворов
                                </div>

                                <img
                                    src="https://e7n.s3.yandex.net/static/certificates-images/certificate_sign_da.png"
                                    alt="signature"
                                    class="signature__image"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="certificate__column certificate__column_right">
                        <img
                            src="https://e7n.s3.yandex.net/static/certificates/webinar/book-logo-elongated.svg"
                            alt="book-logo"
                            class="certificate__book-logo"
                        />
                    </div>
                </div>
            </body>
        </html>
    `;
};
